import { __rest } from "tslib";
import { withWixStyle } from './useWixStyle';
import { withNativeStyle } from './useNativeStyle';
export var themeStrategy = function (_a, experiments, isBmPlatform) {
    var _b;
    if (_a === void 0) { _a = {}; }
    var useWixStyles = _a.useWixStyles, useNativeStyles = _a.useNativeStyles, rest = __rest(_a, ["useWixStyles", "useNativeStyles"]);
    if (experiments === void 0) { experiments = {}; }
    if (isBmPlatform === void 0) { isBmPlatform = false; }
    var isWithWixStylesEnabled = (_b = experiments === null || experiments === void 0 ? void 0 : experiments.withWixStyles) === null || _b === void 0 ? void 0 : _b.enabled;
    var shouldUseWixStyles = useWixStyles !== null && useWixStyles !== void 0 ? useWixStyles : (isBmPlatform && !!isWithWixStylesEnabled);
    return useNativeStyles ? withNativeStyle(rest) : shouldUseWixStyles ? withWixStyle(rest) : rest;
};
//# sourceMappingURL=themeStrategy.js.map